import { combineReducers } from 'redux';
import { resourceReducer } from '@/utils/redux-resource';
import cloneDeep from 'lodash/cloneDeep';

const draft = (state = {}, action) => {
  const newState = cloneDeep(state);
  switch (action.type) {
    case 'SET_DRAFT':
      return action.payload;

    case 'SET_FETCH':
      newState[action.payload.step]
        .fetch = action.payload.fetch;

      return newState;
    case 'SET_ACTION_OUTCOME':
      /* eslint no-case-declarations: "off" */
      let act = newState[action.payload.step]
        .eval[action.payload.evalIndex]
        .actions[action.payload.actionIndex];

      act = { ...act, ...action.payload };

      newState[action.payload.step]
        .eval[action.payload.evalIndex]
        .actions[action.payload.actionIndex] = act;

      return newState;

    case 'SET_EVAL_CONDITIONS':
      newState[action.payload.step]
        .eval[action.payload.evalIndex]
        .conditions = action.payload.conditions;

      return newState;
    case 'DELETE_EVAL':
      newState[action.payload.step]
        .eval.splice(action.payload.evalIndex, 1);

      return newState;
    case 'ADD_EVAL':
      newState[action.payload.step]
        .eval.push(action.payload.evalIndex);

      return newState;
    case 'SET_EXEC_KEY':
      newState[action.payload.step]
        .eval[action.payload.evalIndex]
        .actions[action.payload.actionIndex]
        .nextStep.push(action.payload.execKey);
      return newState;
    default:
      return state;
  }
};

const highlightedStep = (state = [], action) => {
  switch (action.type) {
    case 'HIGHLIGHT_STEP':
      return action.payload;
    default:
      return state;
  }
};

const breadcrumbs = (state = [], action) => {
  switch (action.type) {
    case 'ADD_BREADCRUMB':
      return action.payload;
    default:
      return state;
  }
};

const defaultSnackbar = { visible: false, timeout: 3000, message: '' };
const snackbar = (state = defaultSnackbar, action) => {
  switch (action.type) {
    case 'SET_SNACKBAR':
      return {
        ...state,
        visible: true,
        ...action.payload,
      };
    case 'CLOSE_SNACKBAR':
      return defaultSnackbar;
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const popupList = (state = [], action) => {
  switch (action.type) {
    case 'ADD_POPUP':
      return [...state, action.payload];
    case 'REMOVE_POPUP':
      return [...this.state].splice(1, this.state.length - 1);
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const alertList = (state = [], action) => {
  switch (action.type) {
    case 'ADD_ALERT':
      return [...state, action.payload];
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const globalWorkCount = (state = 0, action) => {
  switch (action.type) {
    case 'ADD_LOAD':
      return state + 1;
    case 'REMOVE_LOAD':
      return state > 1 ? state - 1 : 0;
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const user = (state = null, action) => {
  switch (action.type) {
    case 'SET_USER':
      return action.payload;
    case 'END_SESSION':
      return null;
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const memberProfile = (state = null, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return action.payload;
    case 'END_SESSION':
      return null;
    default:
      return state;
  }
};

/* eslint default-param-last: "off" */
const logList = (state = {}, action) => {
  switch (action.type) {
    case 'ADD_LOGS': {
      const current = cloneDeep(state);
      Object.assign(current, Object.fromEntries(action.payload.map((log) => ([log.id, log]))));
      return current;
    }
    case 'END_SESSION':
      return {};
    default:
      return state;
  }
};

const currentRoute = (state = {}, action) => {
  switch (action.type) {
    case 'SET_CURRENT_ROUTE':
      return action.payload;
    default:
      return state;
  }
};

const endSessionReset = (resourceType) => (state, action) => {
  switch (action.type) {
    case 'END_SESSION':
      return {
        resources: {},
        meta: {},
        requests: {},
        lists: {},
        resourceType,
      };
    default:
      return state;
  }
};

const changeWorkspaceReset = (resourceType) => (state, action) => {
  switch (action.type) {
    case 'CHANGE_WORKSPACE':
      return {
        resources: {},
        meta: {},
        requests: {},
        lists: {},
        resourceType,
      };
    default:
      return state;
  }
};

export default combineReducers({
  user,
  memberProfile,
  globalWorkCount,
  alertList,
  snackbar,
  popupList,
  breadcrumbs,
  highlightedStep,
  draft,
  logList,
  currentRoute,
  workspaceMemberList: resourceReducer('workspaceMemberList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventList: resourceReducer('eventList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventDetail: resourceReducer('eventDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  timeoutList: resourceReducer('timeoutList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  timeoutListDetail: resourceReducer('timeoutListDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  timeoutDetail: resourceReducer('timeoutDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  domainList: resourceReducer('domainList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  domainDetail: resourceReducer('domainDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  domainLogs: resourceReducer('domainLogs', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  credentialList: resourceReducer('credentialList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  credentialDetail: resourceReducer('credentialDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  scheduleList: resourceReducer('scheduleList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  scheduleDetail: resourceReducer('scheduleDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workflowList: resourceReducer('workflowList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workflowDetail: resourceReducer('workflowDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workflowStepList: resourceReducer('workflowStepList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workflowStepDetail: resourceReducer('workflowStepDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workspaceDetail: resourceReducer('workspaceDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  workspaceList: resourceReducer('workspaceList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  templateList: resourceReducer('templateList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventSchemaList: resourceReducer('eventSchemaList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  instanceList: resourceReducer('instanceList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventSchemaDetail: resourceReducer('eventSchemaDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  instanceDetail: resourceReducer('instanceDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventSubscriptionsList: resourceReducer('eventSubscriptionsList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  eventSubscriptionDetail: resourceReducer('eventSubscriptionDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  auditList: resourceReducer('auditList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  auditDetail: resourceReducer('auditDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  msnDetail: resourceReducer('msnDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  campaignList: resourceReducer('campaignList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  campaignDetail: resourceReducer('campaignDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  surveyList: resourceReducer('surveyList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  surveyDetail: resourceReducer('surveyDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  surveyResponses: resourceReducer('surveyResponses', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  fileDetail: resourceReducer('fileDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  pollList: resourceReducer('pollList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  adminPollList: resourceReducer('adminPollList', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  pollDetail: resourceReducer('pollDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  configPollDetail: resourceReducer('configPollDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  resourcePollDetail: resourceReducer('resourcePollDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  resultPollDetail: resourceReducer('resultPollDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  reportPollDetail: resourceReducer('reportPollDetail', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
  lists: resourceReducer('lists', {
    plugins: [
      endSessionReset,
      changeWorkspaceReset,
    ],
  }),
});
